export class BadRequestError extends Error {
  data?: any;

  constructor(data?: any) {
    super('Problem on the request body');
    this.name = 'BadRequestError';
    this.data = data;
  }
}
